export default [
  {
    path: 'dashboard',
    name: 'dashboard',
    component: () => import('@/screens/dashboard/Dashboard.vue'),
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/routes.js